<template>
	<div class="">
		<CLoader :pConfigLoad="ConfigLoad">
			<template slot="BodyFormLoad">
				<div class="row">
					<div class="col-lg-4 form-group">
						<label>Costo Operativo</label>
						<select v-if="this.disable !== 'si'" v-model="ctaporpagar.TipoSelect" @change="filtrarcuentas()" class="form-control">
							<!-- NO VAYAN A CAMBIAR ESTOS ID -->
							<option value="0">Seleccione un departamento</option>
							<!-- <option value="2">Burden</option> -->
							<option value="3">Vehículos</option>
							<!-- -------------------------- -->
							<option value="6">Materiales</option>
							<option value="7">Equipos</option>
							<option value="8">Contratistas</option>
							<option value="9">Viáticos Con Factura</option>
							<option value="14">Viáticos Sin Factura</option>
							<option value="13">Almacén General</option>
							<!-- <option value="10">Mano de Obra Directa</option>
							<option value="11">Mano de Obra Leyes Sociales</option>
							<option value="12">Mano de Obra Otros</option> -->
						</select>
		
						<select v-if="this.disable === 'si'" :disabled="true" v-model="ctaporpagar.TipoSelect" @change="filtrarcuentas()" class="form-control">
							<!-- NO VAYAN A CAMBIAR ESTOS ID -->
							<option value="0">Seleccione un departamento</option>
							<!-- <option value="2">Burden</option> -->
							<option value="3">Vehículos</option>
							<!-- -------------------------- -->
							<option value="6">Materiales</option>
							<option value="7">Equipos</option>
							<option value="8">Contratistas</option>
							<option value="9">Viáticos Con Factura</option>
							<option value="14">Viáticos Sin Factura</option>
							<option value="13">Almacén General</option>
							<!-- <option value="10">Mano de Obra Directa</option>
							<option value="11">Mano de Obra Leyes Sociales</option>
							<option value="12">Mano de Obra Otros</option> -->
						</select>
		
						<Cvalidation v-if="this.errorvalidacion.Departamento" :Mensaje="errorvalidacion.Departamento[0]"/>
					</div>
		
					<div v-if="this.showClient === true && this.disable!=='si'" class="col-lg-8 form-group">
						<label>Cliente</label>
						<treeselect
							@input="branchOfficeList()"
							:options="ListaClientes"
							placeholder="Busque un cliente..."
							v-model="clientesId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaCliente"
						/>
		
						<Cvalidation v-if="this.errorvalidacion.Cliente" :Mensaje="errorvalidacion.Cliente[0]"/>
		
					</div>
		
					<div v-if="this.showClient === true && this.disable === 'si'" class="col-lg-8 form-group">
						<label>Cliente</label>
						<treeselect
							:disabled="true"
							@input="branchOfficeList()"
							:options="ListaClientes"
							placeholder="Busque un cliente..."
							v-model="clientesId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaCliente"
						/>
						<Cvalidation v-if="this.errorvalidacion.Cliente" :Mensaje="errorvalidacion.Cliente[0]"/>
					</div>
		
					<div v-if="this.showClient === true  && this.disable !== 'si'" class="col-lg-4 form-group">
						<label>Cliente Propiedad</label>
						<treeselect
							:maxHeight="200"
							@input="contractList()"
							:options="ListaSucursales"
							placeholder="Busque una propiedad..."
							v-model="sucursalesId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaSucursal" />
		
						<Cvalidation v-if="this.errorvalidacion.Propiedad" :Mensaje="errorvalidacion.Propiedad[0]"/>
					</div>
		
					<div v-if="this.showClient === true  && this.disable === 'si'" class="col-lg-4 form-group">
						<label>Cliente Propiedad</label>
						<treeselect
							:disabled="true"
							:maxHeight="200"
							@input="contractList()"
							:options="ListaSucursales"
							placeholder="Busque una propiedad..."
							v-model="sucursalesId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaSucursal"
						/>
		
						<Cvalidation v-if="this.errorvalidacion.Propiedad" :Mensaje="errorvalidacion.Propiedad[0]"/>
					</div>
		
					<div v-if="this.showClient === true  && this.disable !== 'si'" class="col-lg-4 form-group">
						<label>No. Contrato</label>
						<treeselect
							:maxHeight="200"
							:options="ListaContratos"
							@input="SeleccionarContrato"
							placeholder="Busque un contrato..."
							v-model="contratosId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
						/>
		
						<Cvalidation v-if="this.errorvalidacion.Contrato" :Mensaje="errorvalidacion.Contrato[0]"/>
					</div>
		
					<div v-if="this.showClient === true  && this.disable === 'si'" class="col-lg-4 form-group">
						<label>No. Contrato</label>
						<treeselect
							:disabled="true"
							:maxHeight="200"
							@input="SeleccionarContrato"
							:options="ListaContratos"
							placeholder="Busque un contrato..."
							v-model="contratosId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
						/>
						<Cvalidation v-if="this.errorvalidacion.Contrato" :Mensaje="errorvalidacion.Contrato[0]"/>
					</div>


					<div v-show="this.ShowVehiculo === true" class="col-lg-4 form-group">
						<label>Vehículo</label>
						<treeselect
							:maxHeight="200"
							:options="ListaVehiculo"
							placeholder="Busque un vehículo..."
							v-model="ctaporpagar.IdVehiculo"
						/>
						<Cvalidation v-if="this.errorvalidacion.Cuentas" :Mensaje="errorvalidacion.Cuentas[0]"/>
					</div>
		
					<div v-show="ShowVehiculo" class="col-lg-4 form-group">
						<label for="">Tipo</label>
						<select @change="SelectTipo" v-model="ctaporpagar.TipoOpVehiculo" class="form-control">
							<option value="null">Selecciona un Tipo</option>
							<option value="1">Depreciación o leasing</option>
							<option value="4">Combustible</option>
							<option value="2">Mantenimiento</option>
							<option value="3">Reparaciones</option>
							<option value="5">Refacciones</option>
							<option value="7">Permisos y Licencias</option>
							<option value="6">Seguros</option>
							<option value="8">Renta</option>
							<option value="9">Otros</option>
						</select>
					</div>

					<div v-show="this.showAccout === true && this.disable!=='si' && this.DisableAnio!=='si'" :class="ShowVehiculo===true ? 'col-lg-5 form-group' : 'col-lg-3 form-group'">
						<label>No. Cuenta</label>
						<treeselect
							:maxHeight="200"
							:options="ListaCuentas"
							placeholder="Busque una cuenta..."
							v-model="cuentasId"
						/>
						<Cvalidation v-if="this.errorvalidacion.Cuentas" :Mensaje="errorvalidacion.Cuentas[0]"/>
					</div>

					<div v-show="this.showAccout === true && (this.disable==='si' || this.DisableAnio==='si')" :class="ShowVehiculo===true ? 'col-lg-5 form-group' : 'col-lg-3 form-group'">
						<label>No. Cuenta</label>
						<treeselect
							:disabled="true"
							@input="SeleccionarCuenta"
							:maxHeight="200"
							:options="ListaCuentas"
							placeholder="Busque una cuenta..."
							v-model="cuentasId"
						/>
						<Cvalidation v-if="this.errorvalidacion.Cuentas" :Mensaje="errorvalidacion.Cuentas[0]"/>
					</div>


					<div v-show="this.ShowVehiculo === true" class="col-lg-7 form-group">
						<label for="">Observaciones</label>
						<textarea v-model="ctaporpagar.ObservacionVehiculo" id="" cols="30" rows="2" class="form-control form-control-sm"></textarea>
					</div>

					<div v-show="this.ShowVehiculo === true" class="border-top my-3 col-lg-12"></div>
		
					<template v-if="this.showServiceBilling == true && this.disable!='si'" >
						<div class="border-top my-3 col-lg-12"></div>
		
						<div class="col-lg-4 form-group">
							<label>Servicio</label>
							<select :disabled="DisableTipoServicio || ctaporpagar.Estatus=='SI'" v-model="ctaporpagar.IdConfigS" @change="listServicesType()" class="form-control">
								<!-- NO VAYAN A CAMBIAR ESTOS ID -->
								<option :value="0">Seleccione un Servicio</option>
								<option v-for="(item, index) in ListaServicios" :key="index" :value="item.IdConfigS">
									{{ item.Nombre }}
								</option>
							</select>
							<Cvalidation v-if="this.errorvalidacion.Servicio" :Mensaje="errorvalidacion.Servicio[0]"/>
						</div>
		
						<div class="col-lg-4 form-group">
							<label>Tipo Servicio</label>
							<select :disabled="DisableSubTipoServicio || ctaporpagar.Estatus=='SI'" v-model="ctaporpagar.IdTipoServicio" class="form-control">
								<!-- NO VAYAN A CAMBIAR ESTOS ID -->
								<option :value="0">Seleccione un Tipo Servicio</option>
								<option v-for="(item, index) in ListaTipoServicio" :key="index" :value="item.IdTipoSer">
									{{ item.Concepto }}
								</option>
							</select>
							<Cvalidation v-if="this.errorvalidacion.Tipo_Servicio" :Mensaje="errorvalidacion.Tipo_Servicio[0]"/>
						</div>
		
						<div class="col-lg-4 form-group">
							<label>Concepto</label>
							<input v-show="ctaporpagar.TipoSelect!=9 && ctaporpagar.TipoSelect!=14"
							v-model="ctaporpagar.Concepto"
							type="text"
							placeholder="Concepto"
							class="form-control"
							/>
							<select v-model="ctaporpagar.Concepto" class="form-control" v-show="ctaporpagar.TipoSelect==9 || ctaporpagar.TipoSelect==14">
								<option value="">-Concepto-</option>
								<option value="Comida">Comida</option>
								<option value="Hospedaje">Hospedaje</option>
								<option value="Material Menor">Material Menor</option>
								<option value="Herramienta Menor">Herramienta Menor</option>
								<option value="Transportación">Transportación</option>
								<option value="Renta">Renta</option>
								<option value="Otros">Otros</option>
							</select>
							<label id="lblmsuser" style="Proceso:red">
								<Cvalidation
									v-if="this.errorvalidacion.Concepto"
									:Mensaje="errorvalidacion.Concepto[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="border-top my-3 col-lg-12"></div>
					</template>
		
					<template v-if="this.showServiceBilling === true && this.disable === 'si'">
						<div class="border-top my-3 col-lg-12"></div>
		
						<div class="col-lg-4 form-group">
							<label>Servicio</label>
							<select
							:disabled="DisableTipoServicio || ctaporpagar.Estatus=='SI'"
								v-model="ctaporpagar.IdConfigS"
								@change="listServicesType()"
								class="form-control"
							>
								<!-- NO VAYAN A CAMBIAR ESTOS ID -->
								<option :value="0">Seleccione un Servicio</option>
								<option
									v-for="(item, index) in ListaServicios"
									:key="index"
									:value="item.IdConfigS"
								>
									{{ item.Nombre }}
								</option>
							</select>
							<label id="lblmsuser" style="Proceso:red">
								<Cvalidation
									v-if="this.errorvalidacion.Servicio"
									:Mensaje="errorvalidacion.Servicio[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="col-lg-4 form-group">
							<label>Tipo Servicio</label>
							<select v-model="ctaporpagar.IdTipoServicio" class="form-control" :disabled="DisableSubTipoServicio || ctaporpagar.Estatus=='SI'">
								<!-- NO VAYAN A CAMBIAR ESTOS ID -->
								<option :value="0">Seleccione un Tipo Servicio</option>
								<option
									v-for="(item, index) in ListaTipoServicio"
									:key="index"
									:value="item.IdTipoSer"
								>
									{{ item.Concepto }}
								</option>
							</select>
							<label id="lblmsuser" style="Proceso:red">
								<Cvalidation
									v-if="this.errorvalidacion.Tipo_Servicio"
									:Mensaje="errorvalidacion.Tipo_Servicio[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="col-lg-4 form-group">
							<label>Concepto</label>
							<input
							v-model="ctaporpagar.Concepto"
							type="text"
							placeholder="Concepto"
							class="form-control"
							:disabled="true"
							/>
							<label id="lblmsuser" style="Proceso:red">
								<Cvalidation
									v-if="this.errorvalidacion.Concepto"
									:Mensaje="errorvalidacion.Concepto[0]"
								></Cvalidation
							></label>
						</div>
		
						<div class="border-top my-3 col-lg-12"></div>
					</template>
				</div>
				<div class="row">
					<div class="col-lg-2 form-group">
						<label> Monto </label>
						<vue-numeric
							v-if="this.disable!='si'"
							class="form-control form-finanza "
							currency="$"
							separator=","
							:precision="2"
							v-model="ctaporpagar.Monto"
							placeholder="$0.00"
						></vue-numeric>
						<vue-numeric
							v-if="this.disable=='si'"
							:disabled="true"
							class="form-control  "
							currency="$"
							separator=","
							:precision="2"
							v-model="ctaporpagar.Monto"
							placeholder="$0.00"
						></vue-numeric>
						<label id="lblmsuser" style="Proceso:red">
							<Cvalidation
								v-if="this.errorvalidacion.Monto"
								:Mensaje="errorvalidacion.Monto[0]"
							></Cvalidation
						></label>
					</div>
		
					<div v-if="ShowCombustible" class="col-lg-2">
						<label>Litros</label>
						<vue-numeric
							class="form-control "
							separator=","
							placeholder="0"
							:precision="0"
							v-model="ctaporpagar.Litros"
						></vue-numeric>
					</div>

					<div :class="ShowCombustible ? 'col-lg-5 form-group' : 'col-lg-7 form-group'">
						<label>Proveedores</label>
						<treeselect
							v-if="this.disable!='si'"
							:maxHeight="100"
							@input="get_proveedores(proveedoresId)"
							:options="ListaProveedores"
							placeholder="Busque un proveedor..."
							v-model="proveedoresId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaProveedor"
						/>
		
						<treeselect
							v-if="this.disable=='si'"
							:disabled="true"
							:maxHeight="100"
							@input="get_proveedores(proveedoresId)"
							:options="ListaProveedores"
							placeholder="Busque un proveedor..."
							v-model="proveedoresId"
							noResultsText="Resultados no encontrados"
							noOptionsText="Opciones no disponibles"
							:disable-fuzzy-matching="true"
							@search-change="BusquedaProveedor"
						/>
						<label id="lblmsuser" style="Proceso:red">
							<Cvalidation
								v-if="this.errorvalidacion.Proveedor"
								:Mensaje="errorvalidacion.Proveedor[0]"
							></Cvalidation
						></label>
					</div>
		
					<div class="col-lg-3 form-group" v-show="ctaporpagar.TipoSelect!=14">
						<label>Número Factura o Recibo</label>
						<input
							v-model="ctaporpagar.NumFactura"
							type="text"
							placeholder="Número Factura"
							class="form-control"
						/>
		
						<!-- <input
							v-if="this.disable=='si'"
							:disabled="true"
							v-model="ctaporpagar.NumFactura"
							type="text"
							placeholder="Número Factura"
							class="form-control"
						/> -->
						<label id="lblmsuser" style="Proceso:red">
							<Cvalidation
								v-if="this.errorvalidacion.Numero_Factura"
								:Mensaje="errorvalidacion.Numero_Factura[0]"
							></Cvalidation
						></label>
					</div>
		
					<div class="col-lg-3 form-group">
						<label> {{ctaporpagar.TipoSelect!='14' ? 'Fecha Factura o Recibo' :'Fecha Compra'}} </label>
		
						<v-date-picker
							:masks="{input:'DD-MM-YYYY'}"
							v-if="this.disable!='si'"
							@input="SetAnio();sumDayPay()"
							v-model="ctaporpagar.FechaFactura"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control  calendar',
								style: 'cursor:pointer;background-color:#F9F9F9',
								readonly: true
							}"
							:locale="'es-MX'"
						/>
		
						<v-date-picker
							:masks="{input:'DD-MM-YYYY'}"
							v-if="this.disable=='si'"
							@input="sumDayPay()"
							v-model="ctaporpagar.FechaFactura"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control  calendar',
								style: 'cursor:pointer;background-color:#F9F9F9',
								readonly: true,
								disabled:true
		
							}"
							:locale="'es-MX'"
						/>
						<label id="lblmsuser" style="Proceso:red">
							<Cvalidation
								v-if="this.errorvalidacion.Fecha_Factura"
								:Mensaje="errorvalidacion.Fecha_Factura[0]"
							></Cvalidation
						></label>
					</div>
					<div class="col-lg-3">
						<label for="">Pago</label>
						<select :disabled="ctaporpagar.Estatus=='SI'" @change="SetDiasCredito()" v-model="ctaporpagar.TipoCobro" id="" class="form-control">
							<option value="">-Pago-</option>
							<option value="0">Proveedor</option>
							<option value="1">Reembolso</option>
							<option value="2">Caja Chica</option>
						</select>
					</div>
		
					<div class="col-lg-2 form-group">
						<label> Credito (días) </label>
						<select :disabled="ctaporpagar.Estatus=='SI' || (ctaporpagar.TipoCobro=='1' || ctaporpagar.TipoCobro=='2') || ctaporpagar.TipoSelect=='14'" @change="sumDayPay()" v-if="['','0','7','15','30','45','60','90','120'].includes(ctaporpagar.Credito)" v-model="ctaporpagar.Credito" class="form-control">
							<option value="0">Cont.</option>
							<option value="7">7 días</option>
							<option value="15">15 días</option>
							<option value="30">30 días</option>
							<option value="45">45 días</option>
							<option value="60">60 días</option>
							<option value="90">90 días</option>
							<option value="120">120 días</option>
						</select>
						<!-- <input
							v-if="this.disable!='si' && !['','0','7','15','30','60','90','120'].includes(ctaporpagar.Credito)"
							@input="sumDayPay()"
							class="form-control form-finanza"
							:precision="0"
							v-model="ctaporpagar.Credito"
							placeholder="0"
		
						/> -->
		
						<input
							v-if="this.disable=='si' && !['','0','7','15','30','45','60','90','120'].includes(ctaporpagar.Credito)"
							@input="sumDayPay()"
							class="form-control "
							:precision="0"
							v-model="ctaporpagar.Credito"
							placeholder="0"
							:disabled="true"
							type="text"
						/>
					</div>

					<div class="col-lg-4 form-group" v-show="ctaporpagar.TipoSelect!='14'">
						<label> Factura </label>
						<div class="custom-file-input-image">
							<input
								v-if="this.disable!='si'"
								@change="uploadInvoice()"
								type="file"
								ref="file"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
							/>
		
							<input
								v-if="this.disable=='si'"
								@change="uploadInvoice()"
								type="file"
								ref="file"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
								:disabled="true"
							/>
							<input type="text" v-model="invoice" class="form-control" />
							<button type="button" class="">
								<i class="fas fa-paperclip"></i>
							</button>
						</div>
						<label id="lblmsuser" style="Proceso:red">
							<Cvalidation
								v-if="this.errorvalidacion.Fecha_Pago"
								:Mensaje="errorvalidacion.Fecha_Pago[0]"
							></Cvalidation
						></label>
					</div>
		
					<div class="col-lg-3 form-group" v-show="ctaporpagar.TipoSelect!='14'">
						<label> Fecha Pago </label>
		
						<v-date-picker
						:masks="{input:'DD-MM-YYYY'}"
						v-if="this.disable!='si'"
							@input="dayPay()"
							v-model="ctaporpagar.FechaPago"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control  calendar',
								style: 'cursor:pointer;background-color:#F9F9F9',
								disabled:ctaporpagar.TipoCobro=='1' || ctaporpagar.TipoCobro=='2'
							}"
							:locale="'es-MX'"
						/>
		
						<v-date-picker
						:masks="{input:'DD-MM-YYYY'}"
						v-if="this.disable=='si'"
							@input="dayPay()"
							v-model="ctaporpagar.FechaPago"
							:popover="{
								placement: 'bottom',
								visibility: 'click'
							}"
							:input-props="{
								class: 'form-control  calendar',
								style: 'cursor:pointer;background-color:#F9F9F9',
								readonly: true,
								disabled:true
							}"
							:locale="'es-MX'"
						/>
					</div>
		
					<div v-show="ctaporpagar.TipoCobro=='1' || ctaporpagar.TipoCobro=='2'" class="col-lg-6 form-group">
						<label for="">A Favor de: *</label>
						<select :disabled="ctaporpagar.Estatus=='SI'" v-model="ctaporpagar.IdUsuarioAsignado" class="form-control">
							<option value="">-Trabajador-</option>
							<option v-for="(item,index) in ListaTrabajadores" :key="index" :value="item.IdUsuario">{{item.NombreAdmin}}</option>
						</select>
						<Cvalidation v-if="this.errorvalidacion.Personal"	:Mensaje="errorvalidacion.Personal[0]"></Cvalidation>
					</div>
					<div class="col-lg-12 form-group">
						<label>Comentario</label>
						<textarea v-model="ctaporpagar.ComentarioCuenta" class="form-control" id="" cols="30" rows="4"></textarea>
					</div>
					<div v-show="false" class="col-lg-4 form-group">
						<label> Evidencia 1 </label>
						<div class="custom-file-input-image">
							<input
								v-if="this.disable!='si'"
								@change="uploadEvidenceOne()"
								type="file"
								ref="file2"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
							/>
		
							<input
								v-if="this.disable=='si'"
								@change="uploadEvidenceOne()"
								type="file"
								ref="file2"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
								:disabled="true"
							/>
							<input type="text" v-model="evidenceOne" class="form-control" />
							<button type="button" class="">
								<i class="fas fa-paperclip"></i>
							</button>
						</div>
					</div>
					<div v-show="false" class="col-lg-4 form-group">
						<label> Evidencia 2 </label>
						<div class="custom-file-input-image">
							<input
								v-if="this.disable!='si'"
								@change="uploadEvidenceTwo()"
								type="file"
								ref="file3"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
							/>
		
							<input
								v-if="this.disable=='si'"
								@change="uploadEvidenceTwo()"
								type="file"
								ref="file3"
								name="myfile"
								accept="application/pdf"
								class="custom-file-input"
								id="validatedCustomFile"
								required
								:disabled="true"
							/>
							<input type="text" v-model="evidenceTwo" class="form-control" />
							<button type="button" class="">
								<i class="fas fa-paperclip"></i>
							</button>
						</div>
					</div>
				</div>
			</template>
		</CLoader>
	</div>
</template>
<script>
//El props Id es cuando no es modal y se mando con props
//El export de btnsave es por si no se usa el modal
import Cbtnsave from "@/components/Cbtnsave.vue";
import Cvalidation from "@/components/Cvalidation.vue";

export default {
	name: "Form",
	props: ["IdCtaPagar", "poBtnSave","TipoFiltro"],
	data() {
		return {
			Modal: true, //Sirve pra los botones de guardado
			FormName: "ctaporpagaropera", //Sirve para donde va regresar
			ConfigLoad:{
				ShowLoader:true,
				ClassLoad:true
			},
			ListaCategoria: [],
			ListaCuentas: [],
			ListaProveedores: [],
			ListaProveedoresCopia: [],
			ListaClientes: [],
			ListaClientesCopia: [],
			clientesId: null,
			proveedoresId: null,
			cuentasId: null,
			sucursalesId: null,
			contratosId: null,
			showAccout: false,
			showServiceBilling: false,
			showClient: false,
			ShowVehiculo:false,
			ListaContratos: [],
			ListaContratosPura:[],
			ListaSucursales: [],
			ListaSucursalesCopia: [],
			ListaTipoServicio: [],
			ListaServicios: [],
			ListaDetakke: [],
			ctaporpagar: {
				IdCtaPagar: 0,
				TipoSelect: 0,
				FechaFactura: "",
				FechaPago: "",
				Credito: "0",
				NumFactura: "",
				Monto: "",
				Factura: "",
				ArchivoUno: "",
				ArchivoDos: "",
				IdConfigS: 0,
				IdTipoServicio: 0,
				Concepto:'',
				ComentarioCuenta:"",
				IdVehiculo:null,
				TipoOpVehiculo:null,
				ObservacionVehiculo:'',
				Litros:0,
				IdUsuarioAsignado:'',
				TipoCobro:'',
				Estatus:''
			},
			Anio: "",
			Ruta: "",
			invoice: "Elegir archivo (1 MB)",
			evidenceOne: "Elegir archivo (1 MB)",
			evidenceTwo: "Elegir archivo (1 MB)",
			errorvalidacion: [],
			disable:"",
			DisableAnio:"",
			DisableTipoServicio:false,
			DisableSubTipoServicio:false,
			ListaVehiculo:[],
			ShowCombustible:false,
			Contador:1,
			ListaTrabajadores:[]
		};
	},
	components: {
		Cbtnsave,
		Cvalidation
	},
	methods: {
		SetDiasCredito(){
			this.ctaporpagar.Credito="0";
			this.sumDayPay();
		},
		async Guardar() {
			//deshabilita botones
			this.poBtnSave.toast = 0;
			this.poBtnSave.disableBtn = true;
			// if (this.ctaporpagar.TipoSelect=='3') {
			// 	if (this.ctaporpagar.IdVehiculo==null) {
			// 		this.$toast.warning('Debe seleccionar un vehículo');
			// 		this.poBtnSave.disableBtn = false;
			// 		return false;
			// 	}
			// }

			let formData = new FormData();

			formData.set("IdCtaPagar", this.ctaporpagar.IdCtaPagar);
			formData.set("TipoSelect", this.ctaporpagar.TipoSelect);
			formData.set("IdAsociado", this.cuentasId);
			formData.set("IdProveedor", this.proveedoresId);
			formData.set("TipoCuenta", "OPERA");
			formData.set("FechaFactura", this.ctaporpagar.FechaFactura.toISOString());
			formData.set("FechaPago", this.ctaporpagar.FechaPago.toISOString());
			formData.set("NumFactura", this.ctaporpagar.NumFactura);
			formData.set("Credito", this.ctaporpagar.Credito);
			formData.set("Monto", this.ctaporpagar.Monto);
			formData.set("IdCliente", this.clientesId);
			formData.set("IdSucursalCliente", this.sucursalesId);
			formData.set("IdContrato", this.contratosId);
			formData.set("IdConfigS", this.ctaporpagar.IdConfigS);
			formData.set("IdTipoServicio", this.ctaporpagar.IdTipoServicio);
			formData.set("Concepto", this.ctaporpagar.Concepto);
			formData.set("ComentarioCuenta", this.ctaporpagar.ComentarioCuenta);
			formData.set("IdVehiculo", this.ctaporpagar.IdVehiculo);
			formData.set("TipoOpVehiculo", this.ctaporpagar.TipoOpVehiculo);
			formData.set("ObservacionVehiculo", this.ctaporpagar.ObservacionVehiculo);
			formData.set("IdUsuarioAsignado", this.ctaporpagar.IdUsuarioAsignado);
			formData.set("TipoCobro", this.ctaporpagar.TipoCobro);

			formData.set("Factura", this.ctaporpagar.Factura);
			formData.set("Litros", this.ctaporpagar.Litros);
			if (this.ctaporpagar.Factura == undefined) {
				formData.set("Factura", "");
			}
			formData.set("ArchivoUno", this.ctaporpagar.ArchivoUno);
			if (this.ctaporpagar.ArchivoUno == undefined) {
				formData.set("ArchivoUno", "");
			}
			formData.set("ArchivoDos", this.ctaporpagar.ArchivoDos);
			if (this.ctaporpagar.ArchivoDos == undefined) {
				formData.set("ArchivoDos", "");
			}

			let file = this.$refs.file.files[0];
			formData.append("File", file);

			let file2 = this.$refs.file2.files[0];
			formData.append("File2", file2);

			let file3 = this.$refs.file3.files[0];
			formData.append("File3", file3);

			await this.$http
				.post("ctaporpagar/post", formData)
				.then(res => {
					this.poBtnSave.disableBtn = false;
					this.poBtnSave.toast = 1;
					$("#ModalForm").modal("hide");
					this.bus.$emit("List");
					this.bus.$emit("ListaPrincipal");
				})
				.catch(err => {
					this.errorvalidacion = err.response.data.message.errores;
					this.poBtnSave.disableBtn = false;
					this.poBtnSave.toast = 2;
				});
		},
		Limpiar() {
			this.ctaporpagar = {
				IdCtaPagar: 0,
				TipoSelect: 0,
				FechaFactura: "",
				FechaPago: "",
				Credito: "0",
				NumFactura: "",
				Monto: "",
				Factura: "",
				ArchivoUno: "",
				ArchivoDos: "",
				IdConfigS: 0,
				IdTipoServicio: 0,
				Concepto:"",
				ComentarioCuenta:"",
				IdVehiculo:null,
				TipoOpVehiculo:null,
				ObservacionVehiculo:"",
				Litros:0,
				IdUsuarioAsignado:'',
				TipoCobro:'',
				Estatus:''
			};
			this.showServiceBilling = false;
			this.showClient = false;
			this.showAccout = false;
			this.clientesId = null;
			this.proveedoresId = null;
			this.cuentasId = null;
			this.sucursalesId = null;
			this.contratosId = null;
			this.ShowVehiculo=false;
			this.ShowCombustible=false;
			this.ListaClientes = [];
			this.ListaClientesCopia = [];
			this.ListaContratos = [];
			this.ListaContratosPura = [];
			this.ListaSucursales = [];
			this.ListaSucursalesCopia = [];
			this.ListaVehiculo=[];
			this.invoice = "Elegir archivo (1 MB)";
			this.evidenceOne = "Elegir archivo (1 MB)";
			this.evidenceTwo = "Elegir archivo (1 MB)";
			this.errorvalidacion = [];
			this.$refs.file.value = "";
			this.$refs.file2.value = "";
			this.$refs.file3.value = "";
			this.disable='';
			this.DisableAnio='';
			this.DisableTipoServicio=false,
			this.DisableSubTipoServicio=false
		},
		uploadInvoice() {
			const image = this.$refs.file.files[0];
			var FileSize = image.size / 1024 / 1024; // in MB
			if (FileSize > 1) {
				this.$toast.info("Solo se puede subir archivos menores a 1 MB");
				const input = this.$refs.file;
				input.type = "text";
				input.type = "file";
				return false;
			}
			var allowedExtensions = /(\.pdf|\.PDF)$/i;
			if (!allowedExtensions.exec(image.name)) {
				this.$toast.info("Extenciones permitidas .pdf");
				const input = this.$refs.file;
				input.type = "text";
				input.type = "file";
				this.invoice = "Elegir archivo (1 MB)";
				return false;
			}
			this.invoice = image.name;
		},
		uploadEvidenceOne() {
			const image2 = this.$refs.file2.files[0];
			var FileSize2 = image2.size / 1024 / 1024; // in MB
			if (FileSize2 > 1) {
				this.$toast.info("Solo se puede subir archivos menores a 1 MB");
				const input2 = this.$refs.file2;
				input2.type = "text";
				input2.type = "file";
				return false;
			}
			var allowedExtensions = /(\.pdf|\.PDF)$/i;
			if (!allowedExtensions.exec(image2.name)) {
				this.$toast.info("Extenciones permitidas .pdf");
				const input2 = this.$refs.file2;
				input2.type = "text";
				input2.type = "file";
				this.evidenceOne = "Elegir archivo (1 MB)";
				return false;
			}
			this.evidenceOne = image2.name;
		},
		uploadEvidenceTwo() {
			const image3 = this.$refs.file3.files[0];
			var FileSize3 = image3.size / 1024 / 1024; // in MB
			if (FileSize3 > 1) {
				this.$toast.info("Solo se puede subir archivos menores a 1 MB");
				const input3 = this.$refs.file3;
				input3.type = "text";
				input3.type = "file";
				return false;
			}
			var allowedExtensions = /(\.pdf|\.PDF)$/i;
			if (!allowedExtensions.exec(image3.name)) {
				this.$toast.info("Extenciones permitidas .pdf");
				const input3 = this.$refs.file3;
				input3.type = "text";
				input3.type = "file";
				this.evidenceTwo = "Elegir archivo (1 MB)";
				return false;
			}
			this.evidenceTwo = image3.name;
		},
		sumDayPay() {
			let days = this.ctaporpagar.Credito;
			let dateParam = this.ctaporpagar.FechaFactura;

			if (days > 0) {
				var date = new Date(dateParam);
				date.setDate(dateParam.getDate() + parseInt(days)); //sumamos días a la fecha recibida
				this.ctaporpagar.FechaPago = date; //fecha pago = fecha factura + días de crédito
			}
			else{
				this.ctaporpagar.FechaPago=this.ctaporpagar.FechaFactura;
			}
		},
		dayPay() {
			let dateInvoice = this.ctaporpagar.FechaFactura;
			let datePay = this.ctaporpagar.FechaPago;
			let day = 1000 * 60 * 60 * 24;
			let credit = Math.round((datePay - dateInvoice) / day) + 1;
			this.ctaporpagar.Credito = credit;
		},
		get_one() {
			this.Contador=0;
			this.$http
				.get("ctaporpagar/recovery", {
					params: { IdCtaPagar: this.ctaporpagar.IdCtaPagar }
				})
				.then(res => {
					const objCta = res.data.data.ctaporpagar;

					//importante el órden de los métodos

					this.ClientList();

					this.branchOfficeList(objCta.IdCliente);

					this.contractList(objCta.IdSucursalCliente);

					this.listServices();

					this.listServicesType(objCta.IdConfigS);

					//FIN importante el órden de los métodos
					let FechaReg=objCta.FechaReg.replace(/-/g, "\/");
					if (new Date(FechaReg).getFullYear()!=this.Anio) {
						this.DisableAnio='si';
					}
					this.ctaporpagar.TipoSelect = objCta.TipoSelect;
					this.clientesId = objCta.IdCliente;
					this.sucursalesId = objCta.IdSucursalCliente;
					this.contratosId = objCta.IdContrato;
					this.cuentasId = objCta.IdAsociado;
					this.ctaporpagar.IdConfigS = objCta.IdConfigS;
					this.ctaporpagar.IdTipoServicio = objCta.IdTipoServicio;
					this.ctaporpagar.Monto = objCta.Monto;
					this.proveedoresId = objCta.IdProveedor;
					this.ctaporpagar.NumFactura = objCta.NumFactura;
					this.ctaporpagar.Credito = objCta.Credito;
					this.ctaporpagar.IdVehiculo = objCta.IdVehiculo;
					this.ctaporpagar.TipoOpVehiculo = objCta.TipoOpVehiculo;
					this.ctaporpagar.Concepto = objCta.Concepto == null ? '' : objCta.Concepto;
					this.ctaporpagar.ComentarioCuenta = objCta.ComentarioCuenta;
					this.ctaporpagar.IdUsuarioAsignado = objCta.IdUsuarioAsignado;
					this.ctaporpagar.TipoCobro = objCta.TipoCobro;

					this.get_cuentas(this.ctaporpagar.TipoSelect,true);

					var uno = objCta.FechaPago.replace(/-/g, "\/");
					var dos = objCta.FechaFactura.replace(/-/g, "\/");

					this.ctaporpagar.FechaPago = new Date(uno);
					this.ctaporpagar.FechaFactura = new Date(dos);

					if (objCta.Factura != "undefined" && objCta.Factura != "") {
						this.invoice = objCta.Factura;
						this.ctaporpagar.Factura = objCta.Factura;
					}
					if (objCta.ArchivoUno != "undefined" && objCta.ArchivoUno != "") {
						this.evidenceOne = objCta.ArchivoUno;
						this.ctaporpagar.ArchivoUno = objCta.ArchivoUno;
					}
					if (objCta.ArchivoDos != "undefined" && objCta.ArchivoDos != "") {
						this.evidenceTwo = objCta.ArchivoDos;
						this.ctaporpagar.ArchivoDos = objCta.ArchivoDos;
					}

					this.ctaporpagar.Estatus=objCta.Estatus;
					if (objCta.Estatus=="SI") {
						this.disable='si';
					}
				}).finally(()=>{
					this.ConfigLoad.ShowLoader=false;
					this.Contador++;
				});
		},
		filtrarcuentas() {
			this.ctaporpagar.TipoCobro='';
			this.get_cuentas();
			if (this.ctaporpagar.IdCtaPagar == 0) {
				this.clientesId = null;
			}
			if (this.ctaporpagar.TipoSelect!='3') {
				this.ShowVehiculo=false;
				this.ctaporpagar.IdVehiculo=null;
				this.ctaporpagar.TipoOpVehiculo=null;
				this.ShowCombustible=false;
				this.ctaporpagar.Litros=0;
			}
			else{
				this.ShowVehiculo=true;
				if (this.ctaporpagar.TipoOpVehiculo==4) {
					this.ShowCombustible=true;	
				}
			}
			this.showAccouts();
			this.showServicesBilling();
		},
		async ClientList() {
			await this.$http
				.get("clientes/get", {
					params: {}
				})
				.then(res => {
					this.ListaClientes = res.data.data.clientes.map(function(obj) {
						return { id: obj.IdCliente, label: obj.Nombre };
					});
					this.ListaClientesCopia = res.data.data.clientes.map(function(obj) {
						return { id: obj.IdCliente, label: obj.Nombre };
					});
				});
		},
		async branchOfficeList(id) {
			this.ListaSucursales=[];
			this.ListaSucursalesCopia=[];
			if (typeof id != "undefined" && id!=0) {
				this.clientesId = id;
				this.showClient = true;
			}
			if (this.ctaporpagar.IdCtaPagar == 0) {
				this.sucursalesId = null;
				this.contratosId = null;
			}
			if (this.clientesId!=null) {
				await this.$http
				.get("clientesucursal/get", {
					params: {
						IdCliente: this.clientesId,
						isCuentas:true
					}
				})
				.then(res => {
					this.ListaSucursales = res.data.data.sucursal.map(function(obj) {
						return { id: obj.IdClienteS, label: obj.Nombre };
					});
					this.ListaSucursalesCopia = res.data.data.sucursal.map(function(obj) {
						return { id: obj.IdClienteS, label: obj.Nombre };
					});
				});
			}
		},
		async contractList(id) {
			this.ListaContratos=[];
			this.ListaContratosPura=[];
			if (typeof id != "undefined") {
				this.sucursalesId = id;
			}
			if (this.sucursalesId!=null) {
				await this.$http
				.get("numcontrato/get", {
					params: { IdClienteS: this.sucursalesId }
				})
				.then(res => {
					this.ListaContratosPura=res.data.data.contratosall;
					this.ListaContratos = res.data.data.contratosall.map(function(obj) {
						return { id: obj.IdContrato, label: obj.NumeroC };
					});
					// if (this.ctaporpagar.IdCtaPagar>0) {
					// 	this.SeleccionarContrato();
					// }
				});
			}
		},
		get_cuentas(id,Editar=false) {
			var url = "";
			if (id == 2 || id == 3) {
				this.showAccout = true;
			}
			if (this.ctaporpagar.TipoSelect == 2) {
				url = "costodeptooper/get";

				this.$http
					.get(url, {
						params: { Anio: this.Anio }
					})
					.then(res => {
						this.ListaCuentas = res.data.data.lista.map(function(obj) {
							return {
								id: obj.IdCostoDeptoVenta,
								label: obj.NumeroCuenta
							};
						});
					});
			}

			if (this.ctaporpagar.TipoSelect == 3) {
				let params={Anio: this.Anio};
				url = "costovehope/get";
				if (Editar===true) {
					url = "costovehopesimple/get";
					params={}
				}
				
				this.$http
					.get(url, {
						params: params
					})
					.then(res => {
						let Lista=res.data.data.lista;
						if (Editar===true) {
							Lista=Lista.filter((value) => {
								if (value.Anio==this.Anio || value.IdCostoVehOpe==this.cuentasId) {
									return true;
								}
								else{
									return false;
								}
							})
						}
						this.ListaCuentas = Lista.map(function(obj) {
							return {
								id: obj.IdCostoVehOpe,
								label: obj.NumeroCuenta+' - '+obj.Descripcion
							};
						});
					});
			}
		},
		SetAnio(){
			// var today = new Date(objCta.FechaFactura.replace(/-/g, "\/"));
			var today = new Date(this.ctaporpagar.FechaFactura);
			var yyyy = today.getFullYear();
			this.Anio = yyyy;
			this.cuentasId=null;
			this.ListaCuentas=[];
			if (this.ctaporpagar.TipoSelect!='') {
				this.get_cuentas();	
			}
		},
		async get_proveedores(id) {
			await this.$http
				.get("ctaproveedores/get", {
					params: {}
				})
				.then(res => {
					this.ListaProveedores = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
					this.ListaProveedoresCopia = res.data.data.proveedores.map(function(obj) {
						return { id: obj.IdProveedor, label: obj.Nombre };
					});
					if (this.ctaporpagar.IdCtaPagar == 0) {
						res.data.data.proveedores.filter(obj => {
							if (obj.IdProveedor === id)
								this.ctaporpagar.Credito = obj.DiasCredito;
							return obj;
						});
					}
					this.ListaProveedores.unshift({id:0,label:'Proveedor No Asociado'});
					this.ListaProveedoresCopia.unshift({id:0,label:'Proveedor No Asociado'});
					this.sumDayPay();
				});
		},
		showAccouts() {
			this.showAccout = false;
			this.cuentasId = null;
			if (
				this.ctaporpagar.TipoSelect == 2 ||
				this.ctaporpagar.TipoSelect == 3
			) {
				this.showAccout = true;
			}
		},
		SeleccionarCuenta(){
			if (this.ctaporpagar.TipoSelect=='3') {
				this.ShowVehiculo=true;
			}
		},
		showServicesBilling() {
			this.showServiceBilling = false;
			this.showClient = false;

			this.clientesId = null;
			this.proveedoresId = null;
			this.sucursalesId = null;

			this.ctaporpagar.IdConfigS = 0;
			this.ctaporpagar.IdTipoServicio = 0;
			this.ctaporpagar.Concepto="";
			if (
				this.ctaporpagar.TipoSelect == 6 ||
				this.ctaporpagar.TipoSelect == 7 ||
				this.ctaporpagar.TipoSelect == 8 ||
				this.ctaporpagar.TipoSelect == 9 ||
				this.ctaporpagar.TipoSelect == 14
			) {
				this.listServices();
				this.showServiceBilling = true;
				this.showClient = true;
			}
		},
		async listServices() {
			await this.$http
				.get("baseactual/get", {
					params: {
						RegEstatus: "A",
						Entrada: ""
					}
				})
				.then(res => {
					this.ListaServicios = res.data.data.lista;
				});
		},
		async listServicesType(id) {
			if (id > 0) {
				this.ctaporpagar.IdConfigS = id;
				this.showServiceBilling = true;
			}
			await this.$http
				.get("tiposervicio/get", {
					params: {
						RegEstatus: "A",
						IdConfigS: this.ctaporpagar.IdConfigS,
						IdTipoServ: this.IdTipoServ,
						Entrada: ""
					}
				})
				.then(res => {
					if (typeof id == "undefined") {
						this.ctaporpagar.IdTipoServicio = 0;
					}
					this.ListaTipoServicio = res.data.data.tiposervicio;
				});
		},
		SeleccionarContrato(){
			// console.log(this.Contador);
			if (this.contratosId!=null && this.contratosId!='0' && this.contratosId!='' && this.Contador>0){
				let Index=this.ListaContratosPura.findIndex((element)=>element.IdContrato==this.contratosId);
				if (Index>-1) {
					this.DisableTipoServicio=true;
                    this.DisableSubTipoServicio=true;
					if (this.ListaContratosPura[Index].IdConfigS == 0) {
                        this.factura.IdConfigS='0';
                        this.$toast.warning('Debe Configurar un Tipo de Servicio en el Contrato Para Continuar');
                    }
					else{
						this.ctaporpagar.IdConfigS=this.ListaContratosPura[Index].IdConfigS;
					}

					if (this.ListaContratosPura[Index].IdTipoSer==0) {
                        this.ctaporpagar.IdTipoServicio='0';
                        this.$toast.warning('Debe Configurar un SubTipo de Servicio en el Contrato Para Continuar');
                    }
                    else{
                        this.ctaporpagar.IdTipoServicio=this.ListaContratosPura[Index].IdTipoSer;
                    }
				}
				else{
					this.DisableTipoServicio=false;
                    this.DisableSubTipoServicio=false;
                    this.ctaporpagar.IdConfigS="0";
                    this.ctaporpagar.IdTipoServicio="0";
				}
			}
			else{
				if (this.Contador>0) {
					this.DisableTipoServicio=false;
                	this.DisableSubTipoServicio=false;
                	this.ctaporpagar.IdConfigS="0";
                	this.ctaporpagar.IdTipoServicio="0";	
				}
			}
			this.listServicesType(this.ctaporpagar.IdConfigS);
		},
		BusquedaCliente(val){
			this.ListaClientes=this.$LikeSearch(val,this.ListaClientesCopia);
		},
		BusquedaSucursal(val){
			this.ListaSucursales=this.$LikeSearch(val,this.ListaSucursalesCopia);
		},
		BusquedaProveedor(val){
			this.ListaProveedores=this.$LikeSearch(val,this.ListaProveedoresCopia);
		},
		async GetListaVehiculo(){
			await this.$http.get('vehiculo/get',{
				params:{
					RegEstatus: 'A',
				}
			}).then((res)=>{
				this.ListaVehiculo=res.data.data.vehiculo.map((element)=>{
					return {
						id:element.IdVehiculo,
						label:element.Vehiculo+' '+element.Numero+' '+element.Placa
					}
				})
			})
		},
		SelectTipo(){
			if (this.ctaporpagar.TipoOpVehiculo==4) {
				this.ShowCombustible=true;
			}
			else{
				this.ShowCombustible=false;
				this.ctaporpagar.Litros=0;
			}
		},
		async GetListaTrabajadores(){
			await this.$http.get('trabajador/getselect',{
				params:{
					RegEstatus: 'A',
				}
			}).then((res)=>{
				this.ListaTrabajadores=res.data.data.trabajadores;
			});
		}
	},
	created() {
		this.bus.$off("Nuevo");

		//Este es para moda
		this.bus.$on("Nuevo", (data, Id) => {
			this.ConfigLoad.ShowLoader=true;
			var today = new Date();
			var yyyy = today.getFullYear();
			this.Anio = yyyy;

			this.get_proveedores();
			this.GetListaTrabajadores();
			this.poBtnSave.disableBtn = false;
			this.bus.$off("Save");
			this.bus.$on("Save", () => {
				this.Guardar();
			});

			this.Limpiar();

			this.ClientList();
			this.GetListaVehiculo();

			this.ctaporpagar.FechaFactura = new Date();
			this.ctaporpagar.FechaPago = new Date();
			this.SetAnio();

			if (Id > 0) {
				this.ctaporpagar.IdCtaPagar = Id;
				this.get_one();
			}
			else{
				this.ConfigLoad.ShowLoader=false;
			}
			this.bus.$emit("Desbloqueo", false);
		});
	}
};
</script>
